define(
    'connections/locator-connection',[
        'jquery',
        'server-settings'
    ], 
    function($, settings) {
        return (function() {
            function LocatorConnection() {}

            LocatorConnection.prototype.loadAddresses = function() {
                return $.getJSON(settings.currentPageURL + '/loadAddresses');
            };

            LocatorConnection.prototype.loadAddressViews = function() {
                return $.get(settings.currentPageURL + '/loadAddressViews');
            };

            return new LocatorConnection();
        })();
    }
);
